<script>
    export let row = null;
</script>

<ul>
    {#each row.parts as part}
        <li>{part.quantity}x {part.part}</li>
    {/each}
</ul>